import React from "react";
import { Link } from "react-router-dom";
import { bookingAgreement } from "../data/bookingAgreement";

function BookingAgreement() {
  return (
    <main className="agreement-page">
      <header className="agreement-header">
        <Link to="/" className="agreement-back-link">
          ← Back to Catalogue
        </Link>

        <p className="agreement-eyebrow">
          PLEASE READ BEFORE BOOKING
        </p>

        <h1>{bookingAgreement.title}</h1>

        <p className="agreement-subtitle">
          {bookingAgreement.subtitle}
        </p>

        <span className="agreement-version">
          Version 1.0
        </span>
      </header>

      <div className="agreement-layout">
        <aside className="agreement-toc">
          <h2>In This Agreement</h2>

          <nav aria-label="Agreement sections">
            {bookingAgreement.sections.map((section) => (
              <a
                key={section.id}
                href={`#${section.id}`}
              >
                {section.title}
              </a>
            ))}
          </nav>
        </aside>

        <article className="agreement-content">
          <div className="agreement-notice">
            <strong>Important</strong>
            <p>
              This page currently contains placeholder text.
              The actual policies will be added before the
              agreement is used for real bookings.
            </p>
          </div>

          {bookingAgreement.sections.map((section) => (
            <section
              key={section.id}
              id={section.id}
              className="agreement-section"
            >
              <h2>{section.title}</h2>
              <p>{section.content}</p>
            </section>
          ))}

          <div className="agreement-footer">
            <p>
              Please return to your booking form when you have
              finished reviewing the agreement.
            </p>

            <Link to="/" className="agreement-return-button">
              Return to Catalogue
            </Link>
          </div>
        </article>
      </div>
    </main>
  );
}

export default BookingAgreement;